export const REVIEW_ERROR = {
  NO_ACTIVE_REVIEW: "NO_ACTIVE_REVIEW",
  NOTHING_TO_CONFIRM: "NOTHING_TO_CONFIRM",
  FIELD_NOT_FOUND: "FIELD_NOT_FOUND",
  CANDIDATE_NOT_FOUND: "CANDIDATE_NOT_FOUND",
  CANDIDATE_REQUIRED: "CANDIDATE_REQUIRED",
  BAD_ACTION: "BAD_ACTION",
  WRITE_FAILED: "WRITE_FAILED",
} as const;

export type ReviewErrorCode = (typeof REVIEW_ERROR)[keyof typeof REVIEW_ERROR];

export const STALE_REVIEW_ERRORS: string[] = [
  REVIEW_ERROR.NO_ACTIVE_REVIEW,
  REVIEW_ERROR.NOTHING_TO_CONFIRM,
  REVIEW_ERROR.FIELD_NOT_FOUND,
  REVIEW_ERROR.CANDIDATE_NOT_FOUND,
];
